var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{style:({ color: _vm.color }),attrs:{"icon":[_vm.type, _vm.icon],"size":_vm.size,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }